//The pipe class implements the PipeTransform interface's transform method that accepts an input value and an optional array of parameters and returns the transformed value.
import { Pipe, PipeTransform } from '@angular/core';

//We tell Angular that this is a pipe by applying the @Pipe decorator which we import from the core Angular library.
@Pipe({
  //The @Pipe decorator takes an object with a name property whose value is the pipe name that we'll use within a template expression. It must be a valid JavaScript identifier. Our pipe's name is orderby.
  name: "orderby"
})
export class OrderByPipe implements PipeTransform {
  transform(array:Array<any>, orderByValue: any):Array<any> {
    // Check if array exists, in this case array contains articles and args is an array that has 1 element : !id
    if(array) {
      // get the first element
      // let orderByValue = args[0];
      let byVal = 1;
      // check if exclamation point
      if(orderByValue.charAt(0) == "!") {
        // reverse the array
        byVal = -1;
        orderByValue = orderByValue.substring(1);
      }
      //console.log("byVal",byVal);
      //console.log("orderByValue",orderByValue);
      array.sort((a: any, b: any) => {
        if(a[orderByValue] < b[orderByValue]) {
          return -1*byVal;
        } else if (a[orderByValue] > b[orderByValue]) {
          return 1*byVal;
        } else {
          return 0;
        }
      });
      return array;
    }
    //
  }
}
